<template>
  <v-card>
    <storeInfoDetail />
  </v-card>
</template>

<script>
import storeInfoDetail from "@/components/back-office/InStore/StoreInfoDetail.vue";

export default {
  components: {
    storeInfoDetail
  },
  destroyed() {
    this.$store.commit("fetchStoreBack/resetStateStoreDetail");
    this.$store.commit("fetchCustomerBack/resetState");
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href: "/weserve_admin_login/select/"
      },
      {
        text: "Select service",
        disabled: false,
        href: "/weserve_admin_login/control/" + this.$route.params.province
      },
      {
        text: "Store&Product",
        disabled: false,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/storeandproduct/storemanage"
      },
      {
        text: "Store info",
        disabled: true
      }
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  }
};
</script>

<style>
</style>
